<template>
  <CRow>
    <CCol col="12" md="12" lg="12">
      <b-card header-tag="header" header-bg-variant="dark">
        <template #header>
          <p class="mb-0" style="">
            <strong>Laporan THR</strong>
          </p>
        </template>
        <CRow>
          <CCol col="10">
            <b-form-group label="Tanggal" label-for="tanggal" class="my-0">
              <date-picker class="my-0" id="tanggal" style="width: 100%; margin: 0px" v-model="filter.tanggal"></date-picker>
            </b-form-group>
          </CCol>
          <!-- <CCol col="5">
            <b-form-group
              label="Cabang"
              label-for="cabang"
              class="my-0"
            >
              <Multiselect
                id="cabang"
                v-model="filter.cabang"
                :options="listCabang"
                :multiple="false"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                placeholder="-- Pilih Cabang --"
                label="namaCabang"
                track-by="cabangId"
              ></Multiselect>
            </b-form-group>
          </CCol> -->
          <CCol col="2" style="margin-bottom: 2px">
            <div class="w-100 h-100 d-flex align-items-end">
              <b-button variant="danger" style="" class="d-block w-100" v-c-tooltip.hover.click="'Reset'" @click="reset()">Reset</b-button>
            </div>
          </CCol>
          <CCol col="12" class="mt-1 mb-2"><hr /></CCol>
          <CCol>
            <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
              <template #namaTanggalMulaiKerja-filter>
                <date-picker style="width: 100%" v-model="filter.tanggalMulaiKerja" format="DD MMMM YYYY"></date-picker>
              </template>
              <template #Actions="{ item }">
                <td>
                  <b-button
                    variant="warning"
                    class="mr-1"
                    v-c-tooltip.hover.click="$store.state.table.tooltipEdit"
                    v-b-modal.modal-edit
                    @click="data = item"
                    :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                  >
                    <CIcon name="cil-pencil" />
                  </b-button>
                  <b-button
                    variant="danger"
                    class="mr-1"
                    v-c-tooltip.hover.click="$store.state.table.tooltipHapus"
                    v-b-modal.modal-delete
                    @click="data = item"
                    :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                  >
                    <CIcon name="cil-trash" />
                  </b-button>
                </td>
              </template>
            </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </b-card>
    </CCol>
  </CRow>
</template>

<script>
export default {
  components: {},
  name: "thr",
  data() {
    return {
      data: {},
      // listCabang: [],
      items: [],

      filter: {
        // cabang: null,
        karyawan: null,
        tanggal: null,
        tanggalMulaiKerja: null,
      },
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    fields() {
      let x = [
        {
          key: "no",
          label: this.$store.state.table.no,
          sortDirection: "desc",
          _classes: "table-number text-center",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "namaKaryawan",
          label: this.$store.state.table.namaKaryawan,
          _style: "max-width: 25%;",
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "namaTanggalMulaiKerja",
          label: this.$store.state.table.namaTanggalMulaiKerja,
          _style: "max-width: 20%;",
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "masaKerja",
          label: this.$store.state.table.masaKerja,
          _style: "max-width: 10%;",
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "namaThr",
          label: this.$store.state.table.namaThr,
          _style: "max-width: 15%;",
          sortDirection: "desc",
          _classes: "text-right",
          filter: false,
          sorter: false,
        },
        {
          key: "Actions",
          label: this.$store.state.table.Actions,
          _style: "width: 10%;",
          _classes: "table-option-2 text-center",
          filter: false,
          sorter: false,
        },
      ];

      if (this.$store.state.role_aktif.kodeRole == "super") {
        // Add Mitra column after 'no'
        x.splice(1, 0, {
          key: "namaMitra",
          label: "Mitra",
          _style: "width: 10%;",
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
        });

        // Add namaNominalGajiKaryawan column after 'namaKaryawan'
        x.splice(3, 0, {
          key: "namaNominalGajiKaryawan",
          label: this.$store.state.table.namaNominalGajiKaryawan,
          _style: "max-width: 15%;",
          sortDirection: "desc",
          _classes: "text-right",
          filter: false,
          sorter: false,
        });
      }

      return x;
    },
  },
  mounted() {
    // this.getDatas();
    // this.getCabang();
    this.reset();
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    // 'filter.cabang'(newVal, oldVal) {
    //   if (newVal != oldVal) {
    //     this.getDatas();
    //   }
    // },
    "filter.tanggal"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.tanggalMulaiKerja"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = { ...vm.filter, ...x };
      vm.currentPage = 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listThr = await vm.$axios.post("dataKaryawan/thrKaryawanPerHalaman", {
        ...vm.filter,
        // cabangId: vm.filter.cabang ? vm.filter.cabang.id : null,
        tanggalMulaiKerja: vm.filter.tanggalMulaiKerja ? vm.$moment(vm.filter.tanggalMulaiKerja).format("YYYY-MM-DD") : null,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      console.log("listThr", listThr);
      vm.items =
        listThr.data.status == 200
          ? listThr.data.data.map((x, idx) => {
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                id: x.dataKaryawanId,
                namaMitra: x.namaMitra || " - ",
                namaNominalGajiKaryawan: vm.toNumeric(x.nominalGajiKaryawan, "idr"),
                namaThr: vm.toNumeric(x.thr, "idr"),
                namaTanggalMulaiKerja: vm.$moment(x.tanggalMulaiKontrak).format("LL"),
                masaKerja: x.masaKerja || " - ",
                thr: x.thr || " - ",
                // _cellClasses: {
                //   namaNominalGajiKaryawan: 'text-right',
                //   namaThr: 'text-right',
                // },
              };
            })
          : [];
      vm.totalRows = parseInt(listThr.data.count);
      vm.loading = false;
    },
    // async getCabang() {
    //   let vm = this;
    //   let listCabang = await vm.$axios.get("cabang/list");
    //   vm.listCabang = listCabang.data.status == 200 ? listCabang.data.data : [];
    // },
    reset() {
      const vm = this;
      vm.filter.tanggal = new Date();
      // vm.filter.cabang = vm.$store.state.cabang_aktif
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    toNumeric(number, type) {
      let data = {};
      if (type == "no-idr") {
        return new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
        })
          .format(number)
          .slice(3);
      } else {
        if (type == "idr") data = { style: "currency", currency: "IDR" };
        return new Intl.NumberFormat("id-ID", data).format(number);
      }
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
